import { render, staticRenderFns } from "./RosterProgramEligiblePatients.vue?vue&type=template&id=37319645&scoped=true"
import script from "./RosterProgramEligiblePatients.vue?vue&type=script&lang=js"
export * from "./RosterProgramEligiblePatients.vue?vue&type=script&lang=js"
import style0 from "./RosterProgramEligiblePatients.vue?vue&type=style&index=0&id=37319645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37319645",
  null
  
)

export default component.exports